import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import tempDashboardSelector, {
  tempDashboardDataSelector,
} from '@store/timeline/tempDashboard/selectors';
import { DASHBOARD_TYPE, PAGE_TYPE } from '@utils/constants';
import { initTempDashboard } from '@store/timeline/tempDashboard/actions';
import tempDashboard from '../common/tempDashboard';
import Timeline from './index';
import injectorServer from '../common/injectorServer';

const tempDashboardDetailSelector = createSelector(
  [tempDashboardSelector, tempDashboardDataSelector],
  (tempDashboardStore, tempDashboardDataStore) => ({
    isFetching: tempDashboardStore.isFetching,
    dashboardType: DASHBOARD_TYPE.TIMELINE,
    dashboard: tempDashboardDataStore,
  }),
);

const TempDashboardTimeline = compose(
  connect(tempDashboardDetailSelector, { init: initTempDashboard }),
  tempDashboard,
)(Timeline);

export default injectorServer({}, { pageType: PAGE_TYPE.TEMP_DASHBOARD })(TempDashboardTimeline);
